import { Button, Spin, Table } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { useListUsersQuery } from "./userApi";
import { ReactChild, ReactFragment, ReactPortal } from "react";

const columns = [
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text => <span>{text ? text : "-"}</span>),
  },
  {
    title: "Employee Type",
    dataIndex: "emp_type",
    key: "emp_type",
  },
];

export default function UsersListView() {
  const Navigate = useNavigate()
  const { data, isLoading } =true;
  if (isLoading) return <> <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", height: "90vh" }}>
    <Spin tip="Loading..." />
  </div> </>;
  return (
    <div className="flex flex-col gap-3">
      <div>
        <Link to="/users/invite">
          <Button size="large" type="primary" style={{ display: "flex", alignItems: "center", marginBottom:"13px"}}>
            <PlusOutlined /> Invite User
          </Button>
        </Link>
      </div>
      <Table columns={columns} dataSource={data} pagination={false} />
    </div>
  );
}
